var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClanVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "8px",
    viewBox: "0 0 9 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.6694114%",
    y1: "16.4933638%",
    x2: "84.9909002%",
    y2: "81.4555775%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3F89",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3297C8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clan-verified-profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clan-verified-op4",
    transform: "translate(-211.000000, -305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(211.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-7",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2 3.66666667 3.66666667 5.33333333 8 1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClanVerified);
export default __webpack_public_path__ + "static/media/clan-verified.3d19706bf72047d5eb5781537d9f6568.svg";
export { ForwardRef as ReactComponent };